export const CTA_MIN_WIDTH = '215px'
